<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditDialog="openEditDialog"
      @purchasableApplyApi="purchasableApprovedApi"
      @return="returnApplicationApi"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            v-if="allow('F')"
            :disabled="!checkedRowCount"
            @click="openChooiseFabric"
          >
            {{ $l("btn_batch_update_fabric") || "批量更新面料" }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            v-if="allow('E')"
            :disabled="!checkedRowCount"
            @click="openChooiseTemplate"
          >
            {{ $l("btn_export_nc") || "导出NC赋码文件" }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            v-if="allow('U')"
            :disabled="!checkedRowCount"
            @click="updateSpecSize"
          >
            {{ $l("btn_batch_update_spec") || "批量更新箱规尺寸" }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            v-if="allow('C')"
            :disabled="!checkedRowCount"
            @click="updateCustoms"
          >
            {{ $l("btn_update_of_customs") || "批量更新报关信息" }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
        <!-- <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            v-if="allow('K')"
            :disabled="!checkedRowCount"
            @click="updateMaterialInfo"
          >
            {{ $l("btn_batch_update_materialInfo") || "批量更新材料" }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge> -->
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-primary"
            v-if="allow('A')"
            :disabled="!checkedRowCount"
            @click="purchasableApproved"
          >
            {{ $l("btn_palce_order") || "确认可下单" }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-danger"
            v-if="allow('R')"
            :disabled="!checkedRowCount"
            @click="returnApplication"
          >
            {{ $l("btn_return_application") || "退回申请" }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <SkuDetail
      v-if="skuDetailOpts.visible"
      :type="skuDetailOpts.type"
      :disabled="skuDetailOpts.disabled"
      :visible.sync="skuDetailOpts.visible"
      :amzSkuCode="skuDetailOpts.amzSkuCode"
      :applicationStatus="skuDetailOpts.applicationStatus"
      @reload="reload"
    />
    <SpecSize
      :visible="showSpecSize"
      v-if="showSpecSize"
      @close="showSpecSize = false"
      @saveSpecSize="saveSpecSize"
    />
    <Customs
      :visible="showCustoms"
      v-if="showCustoms"
      @close="showCustoms = false"
      @saveCustoms="saveCustoms"
    />
    <MaterialInfo
      :visible="showMaterialInfo"
      :detailCategoryCode="detailCategoryCode"
      v-if="showMaterialInfo"
      @close="showMaterialInfo = false"
      @saveMaterialInfo="saveMaterialInfo"
    />
    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
    />
    <BatchFabric
      :visible.sync="showBatchFabric"
      :checkedProducts="checkedRows"
      v-if="showBatchFabric"
      @close="showBatchFabric = false"
      @reload="handleBatchFabricReload"
    />
  </div>
</template>
<script>
import PageHeader from "./header";
import PageMain from "./main.vue";
import SkuDetail from "../detail";
import SpecSize from "../spec-size";
import Customs from "../customs";
import MaterialInfo from "../material-info";
import BatchFabric from "../batch-fabric";
import BaseTable from "@/mixins/base-table";
import EditLoading from "@/mixins/edit-loading";
import chooseTemplate from "@/views/ecom/components/choose-template";
import { mapState } from "vuex";

export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageMain,
    PageHeader,
    SkuDetail,
    SpecSize,
    Customs,
    chooseTemplate,
    MaterialInfo,
    BatchFabric,
  },
  data() {
    return {
      usePage: true,
      checkedRows: [],
      showSpecSize: false,
      showCustoms: false,
      showMaterialInfo: false,
      showBatchFabric: false,
      skuDetailOpts: {
        visible: false,
        disabled: false,
        type: "",
        amzSkuCode: "",
        applicationStatus: "",
      },
      detailCategoryCode: "",
      chooseTemplateOptions: {
        visible: false,
        templateGroup: "ecom-goodsOrderReview",
        searchForm: {},
      },
    };
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0;
    },
    ...mapState("admin/user", ["info"]),
  },
  methods: {
    openChooiseFabric() {
      if (!this.checkedRowCount) {
        this.$message({
          message: this.$l("tips_select_sku") || "请选择SKU",
          type: "warning",
        });
        return;
      }
      this.showBatchFabric = true;
    },
    handleBatchFabricReload() {
      this.reload();
      this.clearCheckboxRow();
    },
    openChooiseTemplate() {
      if (!this.checkedRowCount) {
        this.$message({
          message: this.$l("tips_select_order") || "请选择需要SKU",
          type: "warning",
        });
        return;
      }
      this.chooseTemplateOptions.searchForm = {};
      const { userName } = this.info;
      const listAmzSkuCode = this.checkedRows.map((item) => item.amzSkuCode);
      this.chooseTemplateOptions.visible = true;
      this.chooseTemplateOptions.searchForm.codes = listAmzSkuCode;
      this.chooseTemplateOptions.searchForm.userName = userName;
    },
    updateSpecSize() {
      this.showSpecSize = true;
    },
    updateCustoms() {
      this.showCustoms = true;
    },
    updateMaterialInfo() {
      const checkedSpu = Array.from(
        new Set(this.checkedRows.map((e) => e.amzSpuCode))
      );
      if (checkedSpu.length > 1) {
        this.$message({
          message: this.$l("tips_select_spu_too_many") || "存在不同的SPU",
          type: "warning",
        });
        return;
      }
      this.detailCategoryCode = this.checkedRows[0].detailCategoryCode;
      this.showMaterialInfo = true;
    },
    purchasableApply() {
      if (!this.checkedRowCount) {
        this.$message({
          message: this.$l("tips_select_order") || "请选择需要SKU",
          type: "warning",
        });
        return;
      }
      const listAmzSkuCode = this.checkedRows.map((item) => item.amzSkuCode);
      this.purchasableApprovedApi(listAmzSkuCode);
    },
    getData(form) {
      this.loading = true;
      this.$api
        .ecomAmzSkuPlaceListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false;
          this.setData(res);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async saveMaterialInfo(params) {
      const amzSkuCodes = this.checkedRows.map((item) => item.amzSkuCode);
      if (this.loadingOpen()) return;
      const res = await this.$api
        .ecomAmzSkuMaterialInfoSaveApi({ ...params, amzSkuCodes })
        .catch(() => null);
      this.loadingClose();
      if (!res) return;
      const { status } = res;
      if (status !== 200) {
        this.$message.error(this.$l("INDEX.tips_save_no") || "保存失败！");
        return;
      }
      this.$message({
        showClose: true,
        message: this.$l("INDEX.tips_save_ok") || "保存成功！",
        type: "success",
      });
      this.showMaterialInfo = false;
      this.reload();
      this.clearCheckboxRow();
    },
    async saveSpecSize(params) {
      const amzSkuCodes = this.checkedRows.map((item) => item.amzSkuCode);
      if (this.loadingOpen()) return;
      const res = await this.$api
        .ecomAmzSkuSpecSizeSaveApi({ ...params, amzSkuCodes })
        .catch(() => null);
      this.loadingClose();
      if (!res) return;
      const { status } = res;
      if (status !== 200) {
        this.$message.error(this.$l("INDEX.tips_save_no") || "保存失败！");
        return;
      }
      this.$message({
        showClose: true,
        message: this.$l("INDEX.tips_save_ok") || "保存成功！",
        type: "success",
      });
      this.showSpecSize = false;
      this.clearCheckboxRow();
      this.reload();
    },
    async saveCustoms(params) {
      const amzSkuCodes = this.checkedRows.map((item) => item.amzSkuCode);
      if (this.loadingOpen()) return;
      const res = await this.$api
        .ecomAmzSkuSpecCustomsApi({ ...params, amzSkuCodes })
        .catch(() => null);
      this.loadingClose();
      if (!res) return;
      const { status } = res;
      if (status !== 200) {
        this.$message.error(this.$l("INDEX.tips_save_no") || "保存失败！");
        return;
      }
      this.$message({
        showClose: true,
        message: this.$l("INDEX.tips_save_ok") || "保存成功！",
        type: "success",
      });
      this.showCustoms = false;
      this.clearCheckboxRow();
      this.reload();
    },
    async purchasableApprovedApi(listAmzSkuCode) {
      const confirm = await this.$confirm(
        this.$l("tips_pass_place_order") || "是否要通过该SKU可下单申请？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      )
        .then(() => true)
        .catch(() => false);
      if (!confirm) return;
      if (this.loadingOpen()) return;
      const res = await this.$api
        .ecomAmzSkuPurchasableApprovedApi({ listAmzSkuCode })
        .catch(() => null);
      this.loadingClose();
      if (!res) return;
      const { status } = res;
      if (status !== 200) {
        this.$message.error(this.$l("tips_apply_failed") || "申请失败！");
        return;
      }
      this.$message({
        showClose: true,
        message: this.$l("tips_apply_success") || "申请成功！",
        type: "success",
      });
      this.clearCheckboxRow();
      this.reload();
    },
    openEditDialog({ type, data = {} } = {}) {
      const { amzSkuCode, applicationStatus } = data;
      const disabled = type == "detail";
      this.skuDetailOpts = {
        visible: true,
        type,
        disabled,
        amzSkuCode,
        applicationStatus,
      };
    },
    clearCheckboxRow() {
      this.checkedRows = [];
      this.$refs.main.clearCheckboxRow();
    },
    async purchasableApproved() {
      if (!this.checkedRowCount) {
        this.$message({
          message: this.$l("tips_select_sku") || "请选择SKU",
          type: "warning",
        });
        return;
      }
      const confirm = await this.$confirm(
        this.$l("tips_pass_place_order") || "是否要通过该SKU可下单申请？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      )
        .then(() => true)
        .catch(() => false);
      if (!confirm) return false;
      if (this.loadingOpen()) return;
      const listAmzSkuCode = this.checkedRows.map((item) => item.amzSkuCode);
      const res = await this.$api
        .ecomAmzSkuPurchasableApprovedApi({ listAmzSkuCode })
        .catch(() => null);
      this.loadingClose();
      if (!res) return;
      const { status } = res;
      if (status !== 200) {
        this.$message.error(this.$l("tips_pass_failed") || "通过失败！");
        return;
      }
      this.$message({
        showClose: true,
        message: this.$l("tips_pass_success") || "通过成功！",
        type: "success",
      });
      this.clearCheckboxRow();
      this.reload();
    },
    async returnApplication() {
      if (!this.checkedRowCount) {
        this.$message({
          message: this.$l("tips_select_sku") || "请选择SKU",
          type: "warning",
        });
        return;
      }
      const confirm = await this.$confirm(
        this.$l("tips_palce_return_application") || "是否退回申请？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      )
        .then(() => true)
        .catch(() => false);
      if (!confirm) return false;
      if (this.loadingOpen()) return;
      const listAmzSkuCode = this.checkedRows.map((item) => item.amzSkuCode);
      this.returnApp(listAmzSkuCode);
    },
    async returnApplicationApi(listAmzSkuCode) {
      const confirm = await this.$confirm(
        this.$l("tips_palce_return_application") || "是否退回申请？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      )
        .then(() => true)
        .catch(() => false);
      if (!confirm) return;
      if (this.loadingOpen()) return;
      this.returnApp(listAmzSkuCode);
    },
    async returnApp(listAmzSkuCode) {
      const res = await this.$api
        .ecomAmzSkuReturnApplicationApi({ listAmzSkuCode })
        .catch(() => null);
      this.loadingClose();
      if (!res) return;
      const { status } = res;
      if (status !== 200) {
        this.$message.error(this.$l("tips_return_failed") || "退回失败！");
        return;
      }
      this.$message({
        showClose: true,
        message: this.$l("tips_return_success") || "退回成功！",
        type: "success",
      });
      this.clearCheckboxRow();
      this.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
